import { FlexRow } from '@/components/common/Flex';
import { Checkbox, Divider } from '@chakra-ui/react';
import {
    jointOwnerNoOptionLabel,
    jointOwnerYesOptionDescription,
    jointOwnerYesOptionLabel,
} from '@common/react/accountLinking';
import { ArrowLinkText } from '../common/ArrowLinkText';
import { FlexCol } from '../common/Flex';
import { Paragraph, Text } from '../common/Typography';

// N.B. Keep in sync with mobile/components/accountLinking/AccountLinkingConfirmationJointOwnerSubstep.tsx
const AccountLinkingConfirmationJointOwnerSubstep = ({
    isPartnerJointOwner,
    setIsPartnerJointOwner,
    onClickReadMore,
}: {
    isPartnerJointOwner: boolean | null;
    setIsPartnerJointOwner: (isPartnerJointOwner: boolean | null) => void;
    onClickReadMore: VoidFunction;
}) => {
    return (
        <FlexCol>
            <Divider mb={8} />
            <FlexCol gap={6}>
                <FlexRow alignItems="flex-start" gap={4}>
                    <Checkbox
                        size="lg"
                        variant="circular"
                        colorScheme="blue"
                        isChecked={isPartnerJointOwner === true}
                        onChange={() => setIsPartnerJointOwner(true)}
                        mt={2}
                    />
                    <FlexCol gap={2}>
                        <Text
                            cursor="pointer"
                            onClick={() => setIsPartnerJointOwner(true)}
                        >
                            <strong>Yes</strong>, {jointOwnerYesOptionLabel}
                        </Text>
                        <Paragraph fontSize="sm" color="textMuted">
                            {jointOwnerYesOptionDescription}{' '}
                            <ArrowLinkText
                                onClick={onClickReadMore}
                                whiteSpace="nowrap"
                            >
                                Read more
                            </ArrowLinkText>
                        </Paragraph>
                    </FlexCol>
                </FlexRow>
                <FlexRow alignItems="flex-start" gap={4}>
                    <Checkbox
                        size="lg"
                        variant="circular"
                        colorScheme="blue"
                        isChecked={isPartnerJointOwner === false}
                        onChange={() => setIsPartnerJointOwner(false)}
                        mt={2}
                    />
                    <FlexCol>
                        <Text
                            cursor="pointer"
                            onClick={() => setIsPartnerJointOwner(false)}
                        >
                            <strong>No</strong>, {jointOwnerNoOptionLabel}
                        </Text>
                    </FlexCol>
                </FlexRow>
            </FlexCol>
        </FlexCol>
    );
};

export default AccountLinkingConfirmationJointOwnerSubstep;
